import React from 'react';

class SkillIcon extends React.Component { 
        
    handleSkillClick= () =>{
        // this.props.closeToast();
    }
    
    render(){
        const { skillName, iconClassName, skillType } = this.props;
        return (iconClassName && iconClassName.trim().length > 0 ? <><i className={'fas '+iconClassName} title={skillName} ></i> </> : <></>);
    }
}
export default SkillIcon;